import "./helpers/index";
import "./components/index";
const cursor = document.querySelector(".follow-cursor");

document.addEventListener("mousemove", (e) => {
  const { clientX, clientY } = e;
  cursor.style.left = `${clientX}px`;
  cursor.style.top = `${clientY}px`;
  const star = document.createElement("div");
  star.className = "starmouse";
  document.body.appendChild(star);

  const xOffset = (Math.random() - 0.5) * 50;
  const yOffset = (Math.random() - 0.5) * 50;
  const x = e.clientX + xOffset + window.scrollX;
  const y = e.clientY + yOffset + window.scrollY;

  star.style.left = `${x}px`;
  star.style.top = `${y}px`;

  setTimeout(() => {
    star.remove();
  }, 800);
});
